// extracted by mini-css-extract-plugin
module.exports = {"content":"auth-gate-module--content--3lBqx","content__header":"auth-gate-module--content__header--NgyhV"};